const EventEmitter = require('eventemitter')
const config = require('../api/config')
var COUNT_ID = 0

let cacheSub = {}

const SERVICE_TYPE = {
    DYNA: 'DYNA',
    DYNAPOST: 'DYNAPOST',
    DYNAPRE: 'DYNAPRE',
    KLINE: 'KLINE',
    MIN: 'MIN',
    MMP: 'MMP',
    STATISTICS: 'STATISTICS',
    CAPITALFLOW: 'CAPITALFLOW',
    TICK: 'TICK',
    STATIC: 'STATIC',
    INSTRUMENTS: 'INSTRUMENTS',
    STATUS: 'STATUS',
    SECTOR: 'NEWSECTORLIST' // 板块
}

const STATE = {
    unknow: 0,
    error: 1,
    beforeConnect: 2,
    connected: 3,
    disconnected: 4
}

const EVENT = {
    stateChanged: 'stateChanged',
    onMessage: 'onMessage',
    onError: 'onError',
    onClose: 'onClose',
    onOpen: 'onOpen',
    onDYNA: 'onDYNA',
    onDYNAPOST: 'onDYNAPOST',
    onDYNAPRE: 'onDYNAPRE',
    onKLINE: 'onKLINE',
    onMIN: 'onMIN',
    onMMP: 'onMMP',
    onSTATISTICS: 'onSTATISTICS',
    onTICK: 'onTICK',
    onSTATIC: 'onSTATIC',
    onINSTRUMENTS: 'onINSTRUMENTS',
    onSTATUS: 'onSTATUS',
    onSECTOR: 'onNEWSECTORLIST' // 板块
}


class WXQuotationWebSocket extends EventEmitter.EventEmitter {
    static STATE = STATE
    static EVENT = EVENT
    static SERVICE_TYPE = SERVICE_TYPE

    _state = STATE.unknow

    retryTimesCount = 0
    retryTimes = null
    isLog = false
    sendData = []
    userCloseSocket = false
    subscribeSTATISTICSData = []
    subscribeDYNAData = []
    subscribeKLINEData = []
    subscribeMINData = []
    subscribeMMPData = []
    subscribeTICKData = []
    subscribeSTATICData = []
    subscribeINSTRUMENTData = []
    subscribeSTATUSData = []
    subscribeSTATUSData = []
    subscribeDYNAPOSTData = []
    subscribeDYNAPREData = []
    subscribeSECTORData = []
    reqID = 0

    set state(newValue) {
        const oldValue = this._state
        this._state = newValue
        this._log(`stateChanged oldValue:${oldValue} newValue:${newValue}`)
        this.emit(EVENT.stateChanged, oldValue, newValue)
    }

    get state() {
        return this._state
    }

    constructor(url, name = null, protocol = null) {
        super()
        COUNT_ID++
        this._name = name || COUNT_ID + ''
        this.url = url
        this.protocol = protocol
        this.state = STATE.unknow
        this.heartTimer = null
    }

    setHeartBeat() {
        this.heartTimer = window.setInterval(() => {
            this.socketTask && this.socketTask.send(JSON.stringify({
                ServiceType: 'ping'
            }))
        }, 30000)
    }

    clearHeartBeat() {
        window.clearInterval(this.heartTimer)
    }

    connect() {
      this.state = STATE.beforeConnect

      let socketTask
      if (window && window.WebSocket) {
          console.log('this.url', this.url)
          socketTask = new window.WebSocket(this.url)
          this.socketTask = socketTask
              // web端使用
          this.socketTask.onopen = () => {
              if (this.socketTask !== socketTask) {
                  return
              }
              this._log(`onOpen`)

              let authStr = JSON.stringify(config.authConf)
            //   console.log('authStr', authStr)
              this.socketTask.send(authStr)
              this.state = STATE.connected
              this.retryTimesCount = 0
              this.sendData.length > 0 && this.doSendCacheData()
              this.safeSubscribeAll()
              this.emit(EVENT.onOpen)
              this.setHeartBeat()
          }

          this.socketTask.onclose = (data) => {
              this.clearHeartBeat()
              if (this.socketTask !== socketTask) {
                  return
              }
              this._log(`onClose`)
              this.state = STATE.disconnected
              if (!this.userCloseSocket) { // 不是用户主动close都有重新连接
                  this.doReconnect()
              } else {
                  this.userCloseSocket = false
              }
              this.emit(EVENT.onClose, data)
          }

          this.socketTask.onerror = (e) => {
              this.clearHeartBeat()
              if (this.socketTask !== socketTask) {
                  return
              }
              // 需要错误信息应该监听stateChanged 这个时候可以拿到errorMsg
              this._error('onError errorMsg:', e)
              this.state = STATE.error
              this.doReconnect()
              this.emit(EVENT.onError, e)
          }

          this.socketTask.onmessage = (response) => {
              if (this.socketTask !== socketTask) {
                  return
              }

              try {
                  const data = JSON.parse(response.data)
                  this._log('onMessage data:', data)
                  this.emit(EVENT.onMessage, data)

                  this.handleData(data)
              } catch (e) {
                  this._error('JSON.parse errorMsg:', e)
              }
          }
      }
        // return new Promise((resolve, reject) => {

        // })
    }

    safeSubscribeSTATISTICS(Inst, Market) {
        return this.safeSubscribe({ Inst, Market, ServiceType: SERVICE_TYPE.STATISTICS })
    }

    safeUnsubscribeSTATISTICS(Inst, Market) {
        return this.safeUnsubscribe({ Inst, Market, ServiceType: SERVICE_TYPE.STATISTICS })
    }

    safeSubscribeCAPITALFLOW(Inst, Market) {
        return this.safeSubscribe({ Inst, Market, ServiceType: SERVICE_TYPE.CAPITALFLOW })
    }

    safeUnsubscribeCAPITALFLOW(Inst, Market) {
        return this.safeUnsubscribe({ Inst, Market, ServiceType: SERVICE_TYPE.CAPITALFLOW })
    }

    // capitalflow

    

    safeSubscribeDYNA(Inst, Market) {
        return this.safeSubscribe({ Inst, Market, ServiceType: SERVICE_TYPE.DYNA })
    }

    safeUnsubscribeDYNA(Inst, Market) {
        return this.safeUnsubscribe({ Inst, Market, ServiceType: SERVICE_TYPE.DYNA })
    }

    safeSubscribeKLINE(Inst, Market, Period, Limit) {
        return this.safeSubscribe({ Inst, Market, Period, Limit, ServiceType: SERVICE_TYPE.KLINE })
    }

    safeUnsubscribeKLINE(Inst, Market, Period, Limit) {
        return this.safeUnsubscribe({ Inst, Market, Period, Limit, ServiceType: SERVICE_TYPE.KLINE })
    }

    safeSubscribeMIN(Inst, Market, Period, Limit) {
        return this.safeSubscribe({ Inst, Market, Period, Limit, ServiceType: SERVICE_TYPE.MIN })
    }

    safeUnsubscribeMIN(Inst, Market, Period, Limit) {
        return this.safeUnsubscribe({ Inst, Market, Period, Limit, ServiceType: SERVICE_TYPE.MIN })
    }

    safeSubscribeMMP(Inst, Market) {
        return this.safeSubscribe({ Inst, Market, ServiceType: SERVICE_TYPE.MMP })
    }

    safeUnsubscribeMMP(Inst, Market) {
        return this.safeUnsubscribe({ Inst, Market, ServiceType: SERVICE_TYPE.MMP })
    }

    safeSubscribeTICK(Inst, Market, Limit) {
        return this.safeSubscribe({ Inst, Market, Limit, ServiceType: SERVICE_TYPE.TICK })
    }

    safeUnsubscribeTICK(Inst, Market, Limit) {
        return this.safeUnsubscribe({ Inst, Market, Limit, ServiceType: SERVICE_TYPE.TICK })
    }

    safeSubscribeSTATIC(Inst, Market) {
        return this.safeSubscribe({ Inst, Market, ServiceType: SERVICE_TYPE.STATIC })
    }

    safeUnsubscribeSTATIC(Inst, Market) {
        return this.safeUnsubscribe({ Inst, Market, ServiceType: SERVICE_TYPE.STATIC })
    }

    safeSubscribeINSTRUMENTS(Industry, Market, StartID, EndID, SortField) {
        return this.safeSubscribe({ ServiceType: SERVICE_TYPE.INSTRUMENTS, Industry, Market, StartID, EndID, SortField })
    }

    safeUnsubscribeINSTRUMENTS(Industry, Market, StartID, EndID, SortField) {
        return this.safeUnsubscribe({ ServiceType: SERVICE_TYPE.INSTRUMENTS, Industry, Market, StartID, EndID, SortField })
    }

    safeSubscribeSTATUS(Inst, Market) {
        return this.safeSubscribe({ Inst, Market, ServiceType: SERVICE_TYPE.STATUS })
    }

    safeUnsubscribeSTATUS(Inst, Market) {
        return this.safeUnsubscribe({ Inst, Market, ServiceType: SERVICE_TYPE.STATUS })
    }

    safeSubscribeDYNAPOST(Inst, Market) {
        return this.safeSubscribe({ Inst, Market, ServiceType: SERVICE_TYPE.DYNAPOST })
    }

    safeUnsubscribeDYNAPOST(Inst, Market) {
        return this.safeUnsubscribe({ Inst, Market, ServiceType: SERVICE_TYPE.DYNAPOST })
    }

    safeSubscribeDYNAPRE(Inst, Market) {
        return this.safeSubscribe({ Inst, Market, ServiceType: SERVICE_TYPE.DYNAPRE })
    }

    safeUnsubscribeDYNAPRE(Inst, Market) {
        return this.safeUnsubscribe({ Inst, Market, ServiceType: SERVICE_TYPE.DYNAPRE })
    }

    safeSubscribeSECTOR(Inst, Market) {
        // Inst 字段取值如下: SECTORFDHK(方德港股板块) SECTORFDUS(方德美股板块) SECTORRHHK(融汇港股板块) SECTORRHUS(融汇美股板块)
        // Market  字段取值如下: HKSECTOR(港股板块) USSECTOR(美股板块)
        return this.safeSubscribe({ Inst, Market, ServiceType: SERVICE_TYPE.SECTOR })
    }

    safeUnsubscribeSECTOR(Inst, Market) {
        return this.safeUnsubscribe({ Inst, Market, ServiceType: SERVICE_TYPE.SECTOR })
    }

    // 板块的成分股列表
    safeSubscribeSECTORRCONSTITUENT(Inst, Market) {
        // Inst 填板块合约ID，例如BK4002
        // Market  字段取值如下: HKSECTOR(港股板块) USSECTOR(美股板块)
        return this.safeSubscribe({ Inst, Market, ServiceType: SERVICE_TYPE.INSTRUMENTS, Sub: 'Subon' })
    }

    safeUnsubscribeSECTORRCONSTITUENT(Inst, Market) {
        return this.safeUnsubscribe({ Inst, Market, ServiceType: SERVICE_TYPE.INSTRUMENTS, Sub: 'Subon' })
    }

    // 板块成份股排行榜
    safeSubscribeSECTORCONSTITUENTRANKINGS(Inst, Market, Period, SortType) {
        // Inst 填板块合约ID，例如BK4002
        // Market  字段取值如下: HKSECTOR(港股板块) USSECTOR(美股板块)
        // Period 填updown，这个是表示涨跌幅
        // SortType  1是涨幅由大到小排序 0 是涨幅由小到大排序
        return this.safeSubscribe({ Inst, Market, Period, SortType, ServiceType: SERVICE_TYPE.INSTRUMENTS, Sub: 'Subon' })
    }

    safeUnsubscribeSECTORCONSTITUENTRANKINGS(Inst, Market, Period, SortType) {
        return this.safeUnsubscribe({ Inst, Market, Period, SortType, ServiceType: SERVICE_TYPE.INSTRUMENTS, Sub: 'Subon' })
    }

    safeSubscribe(data) {
        const param = Object.assign({
            SubType: 'SUBON'
        }, data)
        return this.safeSend(param)
    }

    safeUnsubscribe(data) {
        const { Inst, Market, ServiceType, Limit } = data
        // 根据Inst，Market，ServiceType获取订阅的ReqID
        const key = Limit ? `${Market}${Inst}_${ServiceType}_${Limit}` : `${Market}${Inst}_${ServiceType}`
        const ReqID = cacheSub[key]
        const param = Object.assign({
            SubType: 'SUBOFF',
            ReqID
        }, data)
        return this.safeSend(param)
    }

    safeSend(data) {
        if (this.state === STATE.connected) {
            return this.send(data)
        }
        this._log(`state no connected sendData cache`, data)
            // 存Data
        this.sendData.push(data)

        if (this.state === STATE.beforeConnect) {
            // return new Promise((resolve, reject) => {
            //   setTimeout(resolve, 0)
            // })
            return
        }
        return this.connect()
    }

    safeSubscribeAll() {
        this._log(`safeSubscribeAll`)
        this.subscribeDYNAData.forEach(item => {
            this.safeSend(item)
        })

        this.subscribeDYNAPOSTData.forEach(item => {
            this.safeSend(item)
        })

        this.subscribeDYNAPREData.forEach(item => {
            this.safeSend(item)
        })

        this.subscribeSTATISTICSData.forEach(item => {
            this.safeSend(item)
        })

        this.subscribeKLINEData.forEach(item => {
            this.safeSend(item)
        })

        this.subscribeMINData.forEach(item => {
            this.safeSend(item)
        })

        this.subscribeMMPData.forEach(item => {
            this.safeSend(item)
        })

        this.subscribeTICKData.forEach(item => {
            this.safeSend(item)
        })

        this.subscribeSTATICData.forEach(item => {
            this.safeSend(item)
        })

        this.subscribeINSTRUMENTData.forEach(item => {
            this.safeSend(item)
        })

        this.subscribeSTATUSData.forEach(item => {
            this.safeSend(item)
        })

        this.subscribeSECTORData.forEach(item => {
            this.safeSend(item)
        })
    }

    unsubscribeFromSaveData(data) {
        switch (data.ServiceType) {
            case SERVICE_TYPE.DYNA:
                let paramDYNA = data
                const stockDYNA = this.subscribeDYNAData.find(item => item.Inst === data.Inst && item.Market === data.Market)
                const indexDYNA = this.subscribeDYNAData.indexOf(stockDYNA)
                this.subscribeDYNAData.splice(indexDYNA, 1)
                if (stockDYNA) {
                    paramDYNA = stockDYNA
                }
                paramDYNA.SubType = 'SUBOFF'
                return paramDYNA
            case SERVICE_TYPE.DYNAPRE:
                let paramDYNAPRE = data
                const stockDYNAPRE = this.subscribeDYNAPREData.find(item => item.Inst === data.Inst && item.Market === data.Market)
                const indexDYNAPRE = this.subscribeDYNAPREData.indexOf(stockDYNAPRE)
                this.subscribeDYNAPREData.splice(indexDYNAPRE, 1)
                if (stockDYNAPRE) {
                    paramDYNAPRE = stockDYNAPRE
                }
                paramDYNAPRE.SubType = 'SUBOFF'
                return paramDYNAPRE
            case SERVICE_TYPE.DYNAPOST:
                let paramDYNAPOST = data
                const stockDYNAPOST = this.subscribeDYNAPOSTData.find(item => item.Inst === data.Inst && item.Market === data.Market)
                const indexDYNAPOST = this.subscribeDYNAPOSTData.indexOf(stockDYNAPOST)
                this.subscribeDYNAPOSTData.splice(indexDYNAPOST, 1)
                if (stockDYNAPOST) {
                    paramDYNAPOST = stockDYNAPOST
                }
                paramDYNAPOST.SubType = 'SUBOFF'
                return paramDYNAPOST
            case SERVICE_TYPE.KLINE:
                let paramKLINE = data
                const stockKLINE = this.subscribeKLINEData.find(item => item.Inst === data.Inst && item.Market === data.Market && item.Period === data.Period && item.Limit === data.Limit)
                const indexKLINE = this.subscribeKLINEData.indexOf(stockKLINE)
                this.subscribeKLINEData.splice(indexKLINE, 1)
                if (stockKLINE) {
                    paramKLINE = stockKLINE
                }
                paramKLINE.SubType = 'SUBOFF'
                return paramKLINE
            case SERVICE_TYPE.MIN:
                let paramMIN = data
                const stockMIN = this.subscribeMINData.find(item => item.Inst === data.Inst && item.Market === data.Market && item.Period === data.Period && item.Limit === data.Limit)
                const indexMIN = this.subscribeMINData.indexOf(stockMIN)
                this.subscribeMINData.splice(indexMIN, 1)
                if (stockMIN) {
                    paramMIN = stockMIN
                }
                paramMIN.SubType = 'SUBOFF'
                return paramMIN
            case SERVICE_TYPE.MMP:
                let paramMMP = data
                const stockMMP = this.subscribeMMPData.find(item => item.Inst === data.Inst && item.Market === data.Market)
                const indexMMP = this.subscribeMMPData.indexOf(stockMMP)
                this.subscribeMMPData.splice(indexMMP, 1)
                if (stockMMP) {
                    paramMMP = stockMMP
                }
                paramMMP.SubType = 'SUBOFF'
                return paramMMP
            case SERVICE_TYPE.STATISTICS:
                let paramSTATISTICS = data
                const stockSTATISTICS = this.subscribeSTATISTICSData.find(item => item.Inst === data.Inst && item.Market === data.Market)
                const indexSTATISTICS = this.subscribeSTATISTICSData.indexOf(stockSTATISTICS)
                this.subscribeSTATISTICSData.splice(indexSTATISTICS, 1)
                if (stockSTATISTICS) {
                    paramSTATISTICS = stockSTATISTICS
                }
                paramSTATISTICS.SubType = 'SUBOFF'
                return paramSTATISTICS
            case SERVICE_TYPE.TICK:
                let paramTICK = data
                const stockTICK = this.subscribeTICKData.find(item => item.Inst === data.Inst && item.Market === data.Market && item.Limit === data.Limit)
                const indexTICK = this.subscribeTICKData.indexOf(stockTICK)
                this.subscribeTICKData.splice(indexTICK, 1)
                if (stockTICK) {
                    paramTICK = stockTICK
                }
                paramTICK.SubType = 'SUBOFF'
                return paramTICK
            case SERVICE_TYPE.STATIC:
                let paramSTATIC = data
                const stockSTATIC = this.subscribeSTATICData.find(item => item.Inst === data.Inst && item.Market === data.Market)
                const indexSTATIC = this.subscribeSTATICData.indexOf(stockSTATIC)
                this.subscribeSTATICData.splice(indexSTATIC, 1)
                if (stockSTATIC) {
                    paramSTATIC = stockSTATIC
                }
                paramSTATIC.SubType = 'SUBOFF'
                return paramSTATIC
            case SERVICE_TYPE.INSTRUMENTS:
                let paramINSTRUMENTS = data
                if (this.subscribeINSTRUMENTData.length) {
                    paramINSTRUMENTS = this.subscribeINSTRUMENTData[0]
                    paramINSTRUMENTS.SubType = 'SUBOFF'
                    this.subscribeINSTRUMENTData.pop()
                }
                return paramINSTRUMENTS
            case SERVICE_TYPE.STATUS:
                let paramSTATUS = data
                const stockSTATUS = this.subscribeSTATUSData.find(item => item.Inst === data.Inst && item.Market === data.Market)
                const indexSTATUS = this.subscribeSTATUSData.indexOf(stockSTATUS)
                this.subscribeSTATUSData.splice(indexSTATUS, 1)
                if (stockSTATUS) {
                    paramSTATUS = stockSTATUS
                }
                paramSTATUS.SubType = 'SUBOFF'
                return paramSTATUS
            case SERVICE_TYPE.SECTOR:
                let paramSECTOR = data
                const stockSECTOR = this.subscribeSECTORData.find(item => item.Inst === data.Inst && item.Market === data.Market)
                const indexSECTOR = this.subscribeSECTORData.indexOf(stockSECTOR)
                this.subscribeSECTORData.splice(indexSECTOR, 1)
                if (stockSECTOR) {
                    paramSECTOR = stockSECTOR
                }
                paramSECTOR.SubType = 'SUBOFF'
                return paramSECTOR
        }
    }

    saveSendData(data) {
        switch (data.ServiceType) {
            case SERVICE_TYPE.DYNA:
                let newDYNAData = this.subscribeDYNAData.filter(function(item) {
                    return (item.Inst !== data.Inst && item.Market !== data.Market)
                })
                this.subscribeDYNAData = newDYNAData
                this.subscribeDYNAData.push(data)
                break
            case SERVICE_TYPE.DYNAPOST:
                let newDYNAPOSTData = this.subscribeDYNAPOSTData.filter(function(item) {
                    return (item.Inst !== data.Inst && item.Market !== data.Market)
                })
                this.subscribeDYNAPOSTData = newDYNAPOSTData
                this.subscribeDYNAPOSTData.push(data)
                break
            case SERVICE_TYPE.DYNAPRE:
                let newDYNAPREData = this.subscribeDYNAPREData.filter(function(item) {
                    return (item.Inst !== data.Inst && item.Market !== data.Market)
                })
                this.subscribeDYNAPREData = newDYNAPREData
                this.subscribeDYNAPREData.push(data)
                break
            case SERVICE_TYPE.KLINE:
                let newKLINEData = this.subscribeKLINEData.filter(function(item) {
                    return (item.Inst !== data.Inst && item.Market !== data.Market && item.Period !== data.Period && item.Limit !== data.Limit)
                })
                this.subscribeKLINEData = newKLINEData
                this.subscribeKLINEData.push(data)
                break
            case SERVICE_TYPE.MIN:
                let newMINData = this.subscribeMINData.filter(function(item) {
                    return (item.Inst !== data.Inst && item.Market !== data.Market && item.Period !== data.Period && item.Limit !== data.Limit)
                })
                this.subscribeMINData = newMINData
                this.subscribeMINData.push(data)
                break
            case SERVICE_TYPE.MMP:
                let newMMPData = this.subscribeMMPData.filter(function(item) {
                    return (item.Inst !== data.Inst && item.Market !== data.Market)
                })
                this.subscribeMMPData = newMMPData
                this.subscribeMMPData.push(data)
                break
            case SERVICE_TYPE.STATISTICS:
                let newSTATISTICSData = this.subscribeSTATISTICSData.filter(function(item) {
                    return (item.Inst !== data.Inst && item.Market !== data.Market)
                })
                this.subscribeSTATISTICSData = newSTATISTICSData
                this.subscribeSTATISTICSData.push(data)
                break
            case SERVICE_TYPE.TICK:
                let newTICKData = this.subscribeTICKData.filter(function(item) {
                    return (item.Inst !== data.Inst && item.Market !== data.Market && item.Limit !== data.Limit)
                })
                this.subscribeTICKData = newTICKData
                this.subscribeTICKData.push(data)
                break
            case SERVICE_TYPE.STATIC:
                let newSTATICData = this.subscribeSTATICData.filter(function(item) {
                    return (item.Inst !== data.Inst && item.Market !== data.Market)
                })
                this.subscribeSTATICData = newSTATICData
                this.subscribeSTATICData.push(data)
                break
            case SERVICE_TYPE.INSTRUMENTS:
                if (this.subscribeINSTRUMENTData.length) {
                    this.subscribeINSTRUMENTData.pop() // 删除
                }
                this.subscribeINSTRUMENTData.push(data)
                break
            case SERVICE_TYPE.STATUS:
                let newSTATUSData = this.subscribeSTATUSData.filter(function(item) {
                    return (item.Inst !== data.Inst && item.Market !== data.Market)
                })
                this.subscribeSTATUSData = newSTATUSData
                this.subscribeSTATUSData.push(data)
                break
            case SERVICE_TYPE.SECTOR:
                let newSECTORData = this.subscribeSECTORData.filter(function(item) {
                    return (item.Inst !== data.Inst && item.Market !== data.Market)
                })
                this.subscribeSECTORData = newSECTORData
                this.subscribeSECTORData.push(data)
                break
        }
    }

    send(data) {
        // return new Promise((resolve, reject) => {
        // 不存在或者没有连接上
        if (!this.socketTask || this.state !== STATE.connected) {
            // return setTimeout(reject, 0)
            return
        }
        if (!data.ReqID && data.ReqID !== 0) {
            data.ReqID = this.reqID++
        }
        const { ReqID, Inst, Market, ServiceType, Limit } = data
        const key = Limit ? `${Market}${Inst}_${ServiceType}_${Limit}` : `${Market}${Inst}_${ServiceType}`
            // 根据Inst，Market，ServiceType存储订阅的ReqID
        cacheSub[key] = ReqID
            // this.saveSendData(data)
        this._log('send data:', data)

        if (window && window.WebSocket) {
            this.socketTask.send(JSON.stringify(data))
        }

        // })
    }

    // 当onOpen时把存的data发出去
    doSendCacheData() {
        const promiseArr = this.sendData.map((data) => {
                this._log(' doSendCacheData')
                return this.safeSend(data)
            })
            // return Promise.all(promiseArr)
        return promiseArr
    }

    close() {
        this.sendData = []
        this.userCloseSocket = true
        if (this.socketTask) {
            this.socketTask.close()
        }
    }

    handleData(data) {
        switch (data.ServiceType) {
            case SERVICE_TYPE.DYNA:
                this.emit(EVENT.onDYNA, data)
                break
            case SERVICE_TYPE.DYNAPOST:
                this.emit(EVENT.onDYNAPOST, data)
                break
            case SERVICE_TYPE.DYNAPRE:
                this.emit(EVENT.onDYNAPRE, data)
                break
            case SERVICE_TYPE.KLINE:
                this.emit(EVENT.onKLINE, data)
                break
            case SERVICE_TYPE.MIN:
                this.emit(EVENT.onMIN, data)
                break
            case SERVICE_TYPE.MMP:
                this.emit(EVENT.onMMP, data)
                break
            case SERVICE_TYPE.STATISTICS:
                this.emit(EVENT.onSTATISTICS, data)
                break
            case SERVICE_TYPE.TICK:
                this.emit(EVENT.onTICK, data)
                break
            case SERVICE_TYPE.STATIC:
                this.emit(EVENT.onSTATIC, data)
                break
            case SERVICE_TYPE.INSTRUMENTS:
                this.emit(EVENT.onINSTRUMENTS, data)
                break
            case SERVICE_TYPE.STATUS:
                this.emit(EVENT.onSTATUS, data)
                break
            case SERVICE_TYPE.SECTOR:
                this.emit(EVENT.onSECTOR, data)
                break
        }
    }

    openLog() {
        this.isLog = true
        return this
    }

    closeLog() {
        this.isLog = true
        return this
    }

    _log(msg, data = '') {
        this.isLog && console.log(`WXQuotationWebSocket.${this._name} ${msg}`, data)
    }
    _error(err, data = '') {
        this.isLog && console.error(`WXQuotationWebSocket.${this._name} ${err}`, data)
    }

    doReconnect() {
        this._log(`doReconnect`)
        if (this.retryTimes === null) {
            return
        }

        if (this.retryTimesCount++ >= this.retryTimes) {
            return
        }
        setTimeout(() => {
            this.connect()
        }, 3000)
    }

    autoReconnect(times = 1000) {
        this.retryTimes = times
    }
}

module.exports = WXQuotationWebSocket
